import { endpoints } from "@/endpoints";
import { Paginated, Avatar } from "@vixi/types";
import { api } from "@/apiInstance";
import { queryOptions } from "@tanstack/react-query";
import { CHARACTER_TYPE } from "@vixi/types";

interface AllAvatarsQueryOptions {
  searchTerm?: string;
  courseId?: number;
}

export const allAvatarsQueryOptions = (
  pageNumber: number,
  pageSize: number,
  { searchTerm, courseId }: AllAvatarsQueryOptions = {},
) =>
  queryOptions({
    queryKey: ["avatars", searchTerm, courseId, pageNumber],
    queryFn: async ({ signal }) => {
      const response = await api.get<Paginated<Required<Avatar>>>(endpoints.getAvatars, {
        params: {
          searchTerm,
          pageNumber,
          pageSize,
          courseId,
          characterType: CHARACTER_TYPE.COURSE_CHARACTER,
        },
        signal,
      });

      return response.data;
    },
  });
